module.exports = __webpack_public_path__ + "static/media/image 3 (1).f7f26d8d.png";